import { EventType, trackEventWithCommonProps } from "@utils/eventTracker";

export const trackException = async (
  exceptionType: "data_issue" | "section_unavailable" | "system_error",
  exceptionName: string,
  pageType: string,
  additionalProps?: Record<string, any>
) => {
  await trackEventWithCommonProps("exception", EventType.PAGE_EVENT, {
    pageType: pageType,
    additionalProps: {
      exception_type: exceptionType,
      exception_name: exceptionName,
      ...additionalProps,
    },
  });
};

// System error exceptions
export const trackSystemError = async (
  errorName: string,
  pageType: string,
  additionalProps?: Record<string, any>
) => {
  await trackException("system_error", errorName, pageType, additionalProps);
};
